// Hospitality H1 (Sep 2026) — the guest side of a hotel referral on the
// restaurant storefront.
//
// The referral itself is created and bound on the SERVER. This module
// only (a) hands the one-time `host_ref` token from the URL to the
// server so it can bind it to this cart session, and (b) asks the
// server whether this session is hotel-referred. The locked delivery
// destination is enforced at checkout by the server whatever this
// module does; what it returns is only for display.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const HOST_PUBLIC = `${BACKEND_URL}/api/host/public`;

export async function fetchHostPage(hostSlug) {
  const { data } = await axios.get(`${HOST_PUBLIC}/${encodeURIComponent(hostSlug)}`);
  return data;
}

export async function createHostReferral(hostSlug, participationId) {
  const { data } = await axios.post(
    `${HOST_PUBLIC}/${encodeURIComponent(hostSlug)}/referrals`,
    { participation_id: participationId },
  );
  return data;
}

export async function bindHostReferral(slug, token, sessionId) {
  const { data } = await axios.post(
    `${HOST_PUBLIC}/storefront/${encodeURIComponent(slug)}/referral/bind`,
    { token, session_id: sessionId },
  );
  return data;
}

export async function fetchHostReferralContext(slug, sessionId) {
  try {
    const { data } = await axios.get(
      `${HOST_PUBLIC}/storefront/${encodeURIComponent(slug)}/referral`,
      { params: { session_id: sessionId } },
    );
    return data;
  } catch (err) {
    if (err?.response?.status === 404) return null;
    throw err;
  }
}

// Only a well-formed, server-issued locked-destination context turns on
// the hotel experience; anything else is treated as "not referred".
export function isHostDestinationContext(ctx) {
  return !!(ctx && ctx.locked === true && ctx.destination && ctx.destination.line1 && ctx.host_display_name);
}

export function formatDestinationLines(context) {
  const d = context?.destination || {};
  const cityLine = [d.city, [d.state, d.postal_code].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  return [d.line1, d.line2, cityLine].filter(Boolean);
}
